import { getI18NConf } from "@/i18n/config"
export default defineI18nConfig(() => getI18NConf())
